import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { RequestNatureOptions } from "@shared/enums/request-nature-options";
import { AgreementContactUs } from "@shared/models/agreement-contact-us.model";
import { RequestConfirmationSummary } from "@shared/models/operational-tasks";
import { RequestReason, RequestType } from "@shared/models/request-types.model";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-action-buttons",
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslateModule, FormsModule, ReactiveFormsModule],
  templateUrl: "./action-buttons.component.html",
})
export class ActionButtonsComponent {
  readonly selectedReference: string = "selectedReference";
  readonly comment: string = "comment";
  readonly selectedTerminationReason: string = "selectedTerminationReason";
  readonly selectedRequestNature: string = "selectedRequestNature";
  readonly selectedTerminationDate: string = "selectedTerminationDate";

  @Input() contactForm!: FormGroup;
  @Input() enableSubmit = false;
  @Input() memberAgreements: AgreementContactUs[] = [];
  @Input() requestNatureOptions: RequestType[] = [];
  @Input() reasonOptions: RequestReason[] = [];

  @Output() showTerminationConfirmationPopup = new EventEmitter<RequestConfirmationSummary>();
  @Output() handleFormSubmit = new EventEmitter<void>();
  @Output() handleFormCancel = new EventEmitter<void>();

  displayConfirmationPopup() {
    const selectedAgreementId = this.contactForm.get(this.selectedReference)?.value;
    const selectedReference = this.memberAgreements.find(a => a.id === selectedAgreementId)?.reference ?? "";
    const selectedRequestNature = this.contactForm.get(this.selectedRequestNature)?.value;
    const requestNatureLabel = this.requestNatureOptions.find(a => a.code === selectedRequestNature)?.longLabel ?? "";

    let summary: RequestConfirmationSummary = {
      contractReference: selectedReference,
      requestNature: requestNatureLabel,
      comments: this.contactForm.get(this.comment)?.value ?? "",
    };

    if (this.contactForm.get(this.selectedRequestNature)?.value === RequestNatureOptions.Termination) {
      const reason =
        this.reasonOptions.find(a => a.code === this.contactForm.get(this.selectedTerminationReason)?.value)
          ?.shortLabel ?? "";
      const currentPolicy = this.memberAgreements.find(
        a => a.id === this.contactForm.get(this.selectedReference)?.value
      );
      summary = {
        ...summary,
        contractReference: currentPolicy?.reference ?? "",
        terminationReason: reason,
        terminationDate: this.contactForm.get(this.selectedTerminationDate)?.value ?? "",
      };
      this.showTerminationConfirmationPopup.emit(summary);
    } else {
      this.handleFormSubmit.emit();
    }
  }

  onCancel(): void {
    this.handleFormCancel.emit();
  }
}
